import { render, staticRenderFns } from "./forgotPasswordSuccess.vue?vue&type=template&id=5a7c2c5d&scoped=true&"
import script from "./forgotPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./forgotPasswordSuccess.vue?vue&type=script&lang=js&"
import style0 from "./forgotPasswordSuccess.vue?vue&type=style&index=0&id=5a7c2c5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7c2c5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VForm,VImg,VRow})
